import {Component, OnInit, ViewChild, AfterViewInit, ElementRef, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {StorageService} from '../../../Services/storage.service';
import {DataService} from '../../../Services/data.service';
import {Title} from '@angular/platform-browser';
import {DateFilterService} from '../../../Services/dateFilter.service';
import {AppConfigService} from '../../../Services/app-config.service';
import {ResponseModel} from '../../../DataModels/response-model';
import {PermissionsService} from '../../../Services/permissions.service';
import {Subscription} from 'rxjs';
import {PagerStateService} from '../../../Services/pager-state.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {InvoiceDocumentService} from '../../../Services/invoice-document.service';
import {EmailModel} from '../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {DatePipe} from '@angular/common';
import {take} from 'rxjs/operators';
import {firstValueFrom} from 'rxjs';
import {NgZone} from '@angular/core';
import {DOC_TYPE_QUOTE} from '../transaction.constants';
import {ListPageBase} from '../../list-page-base';

export interface InvoiceListQuoteVm {
  list: any[];
  batches: any[];
  include: string;
  batchId: string;
  invoiceSearch: string;
  invoiceFromDate: string;
  invoiceToDate: string;
  invoiceToDateOpen: boolean;
  invoiceFromDateOpen: boolean;
  searching: boolean;
  buttonsDisabled: boolean;
  searchHidden: boolean;
  batchesHidden: boolean;
  owingSelected: number;
  totalSelected: number;
  Preferences: any;
  permissions: any;
  title: string;
  tempDescription: string;
  subLedger: string;
}

@Component({
  selector: 'app-invoice-list-quote',
  templateUrl: './invoice-list-quote.component.html',
  styleUrls: ['./invoice-list-quote.component.css'],
  standalone: false
})
export class InvoiceListQuoteComponent extends ListPageBase implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private dateFilter: DateFilterService,
    private titleService: Title,
    private confirmDialogService: ConfirmDialogService,
    private invoiceDoc: InvoiceDocumentService,
    private datePipe: DatePipe,
    private permissionsService: PermissionsService,
    private ngZone: NgZone
  ) {
    super();
  }

  get hasEditQuotePermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditQuotes');
  }

  vm: InvoiceListQuoteVm = {
    list: [],
    batches: [],
    include: 'all',
    batchId: '',
    invoiceSearch: '',
    invoiceFromDate: '',
    invoiceToDate: '',
    invoiceToDateOpen: false,
    invoiceFromDateOpen: false,
    searching: false,
    buttonsDisabled: false,
    searchHidden: false,
    batchesHidden: true,
    owingSelected: 0,
    totalSelected: 0,
    Preferences: {},
    permissions: {},
    title: $localize`:Quotes@@quotes:Quotes`,
    tempDescription: '',
    subLedger: 'quotes',
  };

  isLoaded = false;
  checkAll = false;
  selectedRecords: any[] = [];
  subscriptionGroup: Subscription[] = [];

  todayYmd: string;

  emailDocumentName = 'Quote';
  reportDataToSendInEmail: EmailModel = new EmailModel();

  @ViewChild('myQuoteModal', {read: ElementRef}) modalElementRef!: ElementRef;



  async ngOnInit() {
    this.restorePagerState();
    this.todayYmd = this.datePipe.transform(new Date(), 'yyyyMMdd');

    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    if (this.vm.Preferences?.ShowBatches) {
      this.vm.batchesHidden = !this.vm.Preferences.ShowBatches;
    }

    await this.search();
  }

  ngOnDestroy(): void {
    this.subscriptionGroup.forEach(s => s.unsubscribe());
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.vm.title);
  }

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  async getPagedApiData() {
    this.checkAll = false;
    this.isLoaded = false;
    this.vm.searching = true;
    this.vm.buttonsDisabled = true;
    this.vm.batchId = '';
    this.vm.tempDescription = '';

    const paramString = 'batchType=' + DOC_TYPE_QUOTE
      + '&search=' + (this.vm.invoiceSearch || '')
      + '&fromDate=' + (this.vm.invoiceFromDate ? this.dateFilter.GetDateFormat(this.vm.invoiceFromDate) : '')
      + '&toDate=' + (this.vm.invoiceToDate ? this.dateFilter.GetDateFormat(this.vm.invoiceToDate) : '')
      + '&pageNumber=' + (this.page - 1)
      + '&pageSize=' + this.pageSize;

    try {
      const result: ResponseModel = await firstValueFrom(
        this.tableDataService.getDataWithParams('ListOrders', paramString).pipe(take(1))
      );
      this.vm.list = result.Data as any[];
      this.totalRecords = result.totalRecords;
      this.convertToNumbers();
      this.paginate(false);
    } catch (e) {
      this.notification.showErrorToast('Error loading quotes');
    } finally {
      this.isLoaded = true;
      this.vm.searching = false;
      this.vm.buttonsDisabled = false;
    }
  }

  async search() {
    this.page = 1;
    this.checkAll = false;
    this.isLoaded = false;
    this.vm.searching = true;
    this.vm.buttonsDisabled = true;
    this.vm.batchId = '';
    this.vm.tempDescription = '';

    const paramString = 'batchType=' + DOC_TYPE_QUOTE
      + '&search=' + (this.vm.invoiceSearch || '')
      + '&fromDate=' + (this.vm.invoiceFromDate ? this.dateFilter.GetDateFormat(this.vm.invoiceFromDate) : '')
      + '&toDate=' + (this.vm.invoiceToDate ? this.dateFilter.GetDateFormat(this.vm.invoiceToDate) : '')
      + '&pageNumber=0'
      + '&pageSize=' + this.pageSize;

    try {
      const result: ResponseModel = await firstValueFrom(
        this.tableDataService.getDataWithParams('ListOrders', paramString).pipe(take(1))
      );
      this.vm.list = result.Data as any[];
      this.totalRecords = result.totalRecords;
      this.convertToNumbers();
      this.paginate(false);
    } catch (e) {
      this.notification.showErrorToast('Error loading quotes');
    } finally {
      this.isLoaded = true;
      this.vm.searching = false;
      this.vm.buttonsDisabled = false;
    }
  }

  convertToNumbers() {
    this.vm.list.forEach(item => {
      item.detail_total = Number(item.detail_total);
    });
  }

  selectRow(id: string, checked: boolean) {
    const rec = this.vm.list.find(r => r.id === id);
    if (!rec) {
      return;
    }
    if (checked) {
      if (!this.selectedRecords.find((item) => item.id === id)) {
        this.selectedRecords.push(rec);
      }
    } else {
      this.selectedRecords = this.selectedRecords.filter((item) => item.id !== id);
    }
  }

  selectAllRows(checked: boolean) {
    if (checked) {
      this.vm.list.forEach((item) => {
        if (!this.selectedRecords.find(r => r.id === item.id)) {
          this.selectedRecords.push(item);
        }
      });
    } else {
      this.selectedRecords = this.selectedRecords.filter((item) => !this.vm.list.find(r => r.id === item.id));
    }
  }

  isAllChecked(): boolean {
    return this.vm.list.every((x) => this.selectedRecords.find(r => r.id === x.id));
  }

  confirmDeleteSelected() {
    const selected = this.selectedRecords.filter((x) => this.vm.list.find(r => r.id === x.id));
    if (!selected.length) {
      this.notification.showWarningToast('No records selected');
      return;
    }
    const messages = [`Delete selected records? (${selected.length})`];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.deleteSelected();
      },
      () => {
      }
    );
  }

  async deleteSelected() {
    const selected = this.selectedRecords.filter((x) => this.vm.list.find(r => r.id === x.id));
    for (const item of selected) {
      await firstValueFrom(this.tableDataService.deleteDataById('entry', item.id).pipe(take(1)));
    }
    this.selectedRecords = [];
    await this.search();
  }

  hideBatches() {
    this.vm.batchesHidden = !this.vm.batchesHidden;
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

  clearServerSearch(value: any) {
    this.vm.invoiceSearch = value.searchTerm;
    this.vm.invoiceFromDate = value.fromDate;
    this.vm.invoiceToDate = value.toDate;
    this.page = 1;
    this.search();
  }

  serverSearch(value: any) {
    this.vm.invoiceSearch = value.searchTerm;
    this.vm.invoiceFromDate = value.fromDate;
    this.vm.invoiceToDate = value.toDate;
    this.page = 1;
    this.search();
  }

  async email(id: any) {
    try {
      const emailObj: any = await this.invoiceDoc.buildEmailModelById(String(id), 'quotes');
      this.reportDataToSendInEmail = emailObj;
      this.reportDataToSendInEmail.print_orientation = 'portrait';
      this.reportDataToSendInEmail.convert_attachment_to = 'pdf';
      this.reportDataToSendInEmail.includeAttachment = true;
      if (this.modalElementRef) {
        const modalDiv = this.modalElementRef.nativeElement.querySelector('.modal');
        if (modalDiv) {
          const modal = Modal.getOrCreateInstance(modalDiv);
          modal.show();
        }
      }
    } catch (e) {
      console.error('Unable to open email modal for quote id:', id, e);
      this.notification.showErrorToast(`Unable to prepare email`);
    }
  }

  onNavigate(id: string, print = false) {
    if (print) {
      try {
        this.invoiceDoc.printById(String(id), 'quotes');
        return;
      } catch (e) {
        this.router.navigate(['/transactions/invoice/quote/form'], {queryParams: {invoiceId: id, action: 'print'}}).then();
        return;
      }
    }
    this.router.navigate(['/transactions/invoice/quote/form'], {queryParams: {invoiceId: id}}).then((r) => r);
  }

  getBatchItems(batchId: string) {
    this.page = 1;
    this.isLoaded = false;
    this.vm.searching = true;
    this.vm.buttonsDisabled = true;

    const paramString = 'batchType=' + DOC_TYPE_QUOTE
      + '&batchId=' + batchId
      + '&pageNumber=0'
      + '&pageSize=' + this.pageSize
      + '&include=all';

    firstValueFrom(
      this.tableDataService.getDataWithParams('entry', paramString).pipe(take(1))
    ).then(result => {
      this.vm.list = (result as ResponseModel).Data as any[];
      this.totalRecords = (result as ResponseModel).totalRecords;
      this.convertToNumbers();
      this.paginate(false);
    }).catch(() => {
      this.notification.showErrorToast('Error loading batch items');
    }).finally(() => {
      this.isLoaded = true;
      this.vm.searching = false;
      this.vm.buttonsDisabled = false;
    });
  }
}
